(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/react/debugger.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/react/debugger.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useAtomValue
} = jotai;
const {
  useEffect,
  useState,
  useRef,
  useMemo
} = React;
function findJotai() {
  const stack = [svs.lyckoplatsen];
  const visited = new Set();
  const results = [];
  while (stack.length) {
    const obj = stack.pop();
    visited.add(obj);
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (key === 'jotai') {
          results.push(obj[key]);
        } else if (typeof obj[key] === 'object' && obj[key] !== null && !visited.has(obj[key])) {
          stack.push(obj[key]);
        }
      }
    }
  }
  return results;
}
function formatAtoms(data) {
  const formattedData = {
    atoms: []
  };
  data.forEach(entry => {
    if (entry.atoms) {
      Object.keys(entry.atoms).forEach(atomKey => {
        formattedData.atoms.push({
          [atomKey]: entry.atoms[atomKey]
        });
      });
    }
  });
  return formattedData;
}
const Debugger = () => {
  const [isExpanded, setIsExpanded] = useState({});
  const [highlightedAtoms, setHighlightedAtoms] = useState({});
  const [showData, setShowData] = useState(false);
  const prevAtomValuesRef = useRef([]);
  const allJotai = useMemo(() => findJotai(), []);
  const formattedAtoms = useMemo(() => formatAtoms(allJotai), [allJotai]);
  const atomList = useMemo(() => formattedAtoms.atoms.map(atomObject => {
    const atomKey = Object.keys(atomObject)[0];
    return {
      atomKey,
      atom: atomObject[atomKey]
    };
  }), [formattedAtoms]);
  const atomValues = atomList.map(_ref => {
    let {
      atomKey,
      atom
    } = _ref;
    const atomValue = useAtomValue(atom);
    return {
      atomKey,
      atomValue
    };
  });
  useEffect(() => {
    const currentValues = atomValues.map(_ref2 => {
      let {
        atomValue
      } = _ref2;
      return atomValue;
    });
    currentValues.forEach((currentValue, index) => {
      const prevValue = prevAtomValuesRef.current[index];
      if (JSON.stringify(currentValue) !== JSON.stringify(prevValue)) {
        setHighlightedAtoms(prev => _objectSpread(_objectSpread({}, prev), {}, {
          [index]: true
        }));
        setTimeout(() => {
          setHighlightedAtoms(prev => _objectSpread(_objectSpread({}, prev), {}, {
            [index]: false
          }));
        }, 2000);
      }
    });
    prevAtomValuesRef.current = currentValues;
  }, [atomValues]);
  const toggleExpand = index => {
    setIsExpanded(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [index]: !prev[index]
    }));
  };
  const renderAtomValue = (atomValue, atomIndex) => {
    if (Array.isArray(atomValue) && atomValue.length > 0) {
      return atomValue.map((item, itemIndex) => React.createElement("div", {
        className: "margin-bottom",
        key: itemIndex
      }, React.createElement("div", {
        className: "pointer",
        onClick: () => toggleExpand("".concat(atomIndex, "-").concat(itemIndex))
      }, isExpanded["".concat(atomIndex, "-").concat(itemIndex)] ? '▼' : '▶', " ", itemIndex), isExpanded["".concat(atomIndex, "-").concat(itemIndex)] && React.createElement("div", {
        className: "padding-left-1"
      }, typeof item === 'object' ? React.createElement("pre", null, JSON.stringify(item, null, 2)) : React.createElement("span", null, item))));
    }
    if (typeof atomValue === 'object' && atomValue !== null) {
      return React.createElement("pre", null, JSON.stringify(atomValue, null, 2));
    }
    return React.createElement("span", null, String(atomValue));
  };
  return React.createElement("div", {
    className: "lp-debugger-container"
  }, React.createElement("div", {
    className: "debugger-button pointer",
    type: "button",
    onClick: () => setShowData(prev => !prev)
  }, "\uD83D\uDC7B"), showData && React.createElement("div", {
    className: "lp-debugger-list"
  }, atomValues.map((_ref3, atomIndex) => {
    let {
      atomKey,
      atomValue
    } = _ref3;
    const classNames = ['pointer bold'];
    const noAtomValue = !atomValue || Array.isArray(atomValue) && !atomValue.length;
    if (highlightedAtoms[atomIndex]) {
      classNames.push('highlight-green');
    }
    if (noAtomValue) {
      classNames.push('highlight-orange');
    }
    return React.createElement("div", {
      className: "margin-bottom-1",
      key: atomIndex
    }, React.createElement("div", {
      className: classNames.join(' '),
      onClick: () => toggleExpand(atomIndex)
    }, isExpanded[atomIndex] ? '▼' : '▶', " ", atomKey), isExpanded[atomIndex] && React.createElement("div", {
      className: "padding-left-1 ".concat(noAtomValue ? 'highlight-orange' : '')
    }, renderAtomValue(atomValue, atomIndex)));
  })));
};
Object.assign(svs.lyckoplatsen.react, {
  Debugger
});

 })(window);